<template>
  <div
    class="mood-inverse flex min-h-[60vh] flex-col items-center justify-center bg-[#191c20] px-24 py-48 text-static-default-hi"
  >
    <div class="flex flex-col items-center text-center">
      <div class="bg-static-warning-low rounded-full p-4">
        <IconClock class="text-static-warning-hi" size="48" />
      </div>

      <h1 class="heading-1 mt-16">
        {{ i18n(translations.title) }}
      </h1>

      <p class="body-1 text-static-default-low mt-8">
        {{ i18n(translations.description) }}
      </p>

      <RevButton :to="{ name: OUTLET.HOME }" variant="primary" class="mt-20">
        {{ i18n(translations.seeSimilarItems) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { IconClock } from '@ds/icons/IconClock'

import { OUTLET } from '../../../../routes-names'

import translations from './SoldOutPage.translations'

const i18n = useI18n()
</script>
